{
  "common.close": "Sluiten",
  "common.athleteFallback": "atleet {id}",
  "splash.title": "{app} — geanimeerde activiteitenvisualisatie",
  "splash.tagline": "Je Strava&nbsp;gegevens in beweging",
  "splash.demo": "Demo",
  "tab.query.title": "Kaart van {name}",
  "tab.query.heading": "Activiteiten opvragen:",
  "tab.query.optDays": "recente dagen",
  "tab.query.optActivities": "recente activiteiten",
  "tab.query.optIds": "Activiteit-ID's",
  "tab.query.optDates": "Datumbereik",
  "tab.query.idsPlaceholder": "voer hier activiteit-ID's in",
  "tab.query.after": "Vanaf:",
  "tab.query.before": "Tot:",
  "tab.query.autozoom": "Na import automatisch inzoomen <i class=\"hf hf-bullseye\"></i> op de zoekopdracht",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Opvragen",
  "tab.query.createAccount": "Maak een account aan en/of log in.",
  "tab.query.sports": "Sporten:",
  "tab.query.allSports": "Alle sporten",
  "tab.query.sportsExcept": "Alle behalve",
  "tab.query.sportsNone": "Geen",
  "tab.query.loadingSports": "Sporten laden…",
  "tab.query.sportsFailed": "De sporten van deze kaart konden niet worden geladen",
  "tab.query.noSports": "Nog geen activiteiten",
  "tab.activities.title": "Weergegeven activiteiten",
  "tab.activities.clearSelection": "Selectie wissen",
  "tab.activities.renderSelected": "Selectie weergeven",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Zoomen naar selectie",
  "tab.controls.title": "Laaginstellingen",
  "tab.controls.timescale": "Tijdschaal <i>&tau;</i>",
  "tab.controls.timescaleHint": "afspeelsnelheid",
  "tab.controls.period": "Periode <i>T</i>",
  "tab.controls.periodHint": "activiteit ~ model",
  "tab.controls.dotSize": "Puntgrootte",
  "tab.controls.pathWidth": "Lijndikte",
  "tab.controls.pathWidthHint": "nul verbergt de lijnen",
  "tab.controls.colors": "Kleuren",
  "tab.controls.colorsHint": "palet draaien",
  "tab.controls.shadows": "Schaduwen",
  "tab.profile.loginTitle": "Inloggen",
  "tab.profile.anonNote": "Log in met Strava om je eigen activiteiten te zien en je Heatflask-account te beheren.",
  "tab.profile.loginLink": "Inloggen met Strava",
  "tab.profile.editOnStrava": "Je profiel bewerken op Strava",
  "tab.profile.indexNote": "We indexeren je activiteitsoverzichten voor snelle toegang.",
  "tab.profile.viewIndex": "Index bekijken",
  "tab.profile.sharedMaps": "Gedeelde kaarten",
  "tab.profile.sharedMapsNote": "Uit: alleen jij ziet je activiteiten op Heatflask. Aan: iedereen met een link naar je kaart ziet de activiteiten die je op Strava openbaar hebt gemaakt. Je privéactiviteiten blijven hoe dan ook van jou. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Hoe privacy werkt</a>",
  "tab.profile.logout": "Uitloggen",
  "tab.profile.deleteAccount": "Account verwijderen",
  "tab.profile.deleteConfirm": "Je Heatflask-account verwijderen?\n\nHiermee worden je geïndexeerde activiteiten verwijderd en wordt de toegang van Heatflask tot je Strava-gegevens ingetrokken. Dit kan niet ongedaan worden gemaakt.",
  "tab.profile.languageHeading": "Taal",
  "tab.profile.languageAuto": "Automatisch",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Help ons vertalingen te verbeteren of nieuwe toe te voegen!</a>",
  "tab.profile.unitsHeading": "Eenheden",
  "tab.profile.unitsAuto": "Automatisch",
  "tab.profile.unitsMetric": "Metrisch (km, m)",
  "tab.profile.unitsImperial": "Imperiaal (mi, ft)",
  "tab.profile.textSizeHeading": "Tekstgrootte",
  "tab.profile.textSmaller": "Kleiner",
  "tab.profile.textReset": "Normaal",
  "tab.profile.textLarger": "Groter",
  "tab.profile.mapDefaultsHeading": "Kaartstandaarden",
  "tab.profile.mapDefaultsNote": "Begin met deze basiskaart, dit terrein en deze laaginstellingen wanneer je een kaart opent waarvan de link geen eigen instellingen bevat. Links die je deelt tonen nog steeds precies wat jij ziet.",
  "tab.profile.mapDefaultsSave": "Opslaan als mijn standaard",
  "tab.profile.mapDefaultsForget": "Vergeten",
  "tab.info.title": "Info",
  "tab.info.controlsHeading": "Bediening",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + slepen",
  "tab.info.shiftDragDesc": "Selecteer activiteiten met een kader. Tik op een touchscreen eerst op <i class=\"hf-object-group\"></i> en sleep dan met één vinger. De laatst geselecteerde activiteit toont haar details, en de activiteitenlijst scrolt ernaartoe.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + slepen",
  "tab.info.ctrlDragDesc": "Draai en kantel de kaart in 3D, of gebruik twee vingers",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Zijbalk openen of sluiten",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Vorig of volgend tabblad",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Zijbalk sluiten",
  "tab.info.liveUrlHeading": "Live-URL",
  "tab.info.liveUrlDesc": "De kaartweergave en de animatie-instellingen staan in de URL van de pagina, zodat iedereen met wie je die deelt hetzelfde beeld ziet.",
  "tab.info.videoHeading": "Video-export",
  "tab.info.videoDesc": "De knop <i class=\"hf-video-camera\"></i> neemt de animatie op als MP4: tik erop, zet het kader over het deel van de kaart dat je wilt en tik nogmaals om op te nemen. Er wordt één volledige lus van de animatie opgenomen, zodat de video naadloos herhaalt; een lus langer dan {max} seconden (de langste video die Strava accepteert) wordt na {max} seconden afgekapt.",
  "tab.info.contributeHeading": "Bijdragen",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Sponsor op GitHub",
  "tab.info.contactsHeading": "Contact",
  "map.basemapAndTerrain": "Achtergrondkaart en terrein",
  "map.pauseAnimation": "Animatie pauzeren",
  "map.resumeAnimation": "Animatie hervatten",
  "capture.record": "Video opnemen (lus van {period} s)",
  "capture.recordTruncated": "Video opnemen (één cyclus duurt {period} s; alleen de eerste {max} s worden opgenomen)",
  "capture.recordArea": "Het gebied binnen het kader opnemen",
  "capture.stop": "Opname stoppen",
  "capture.selectionTooSmall": "selectie is te klein",
  "capture.saved": "{name} opgeslagen ({size})",
  "capture.cancelled": "opname geannuleerd",
  "capture.failed": "opname mislukt: {error}",
  "capture.loadingEncoder": "encoder laden…",
  "capture.waitingForMap": "wachten tot de kaart geladen is…",
  "capture.encoding": "coderen… {percent}%",
  "capture.finalizing": "afronden…",
  "share.title": "Deel een link naar deze kaart",
  "share.copied": "link gekopieerd",
  "share.copiedUnshared": "link gekopieerd — maar je kaart wordt niet gedeeld, dus niemand anders kan hem openen. Zet ‘Gedeelde kaarten’ aan om dat te veranderen.",
  "share.unshared": "Je kaart wordt niet gedeeld, dus niemand anders kan deze link openen. Zet ‘Gedeelde kaarten’ aan om dat te veranderen.",
  "share.copyThis": "Kopieer deze link:",
  "update.available": "Er is een nieuwe versie van Heatflask beschikbaar.",
  "update.reload": "Opnieuw laden",
  "import.title": "Importeren",
  "import.stop": "Stoppen",
  "import.stopping": "stoppen…",
  "import.contacting": "verbinden met Strava…",
  "import.countOf": "{received} van {total} activiteiten",
  "import.count": "Activiteiten: {received}",
  "import.waitStrava": "Gepauzeerd tot {time} door de downloadlimiet van Strava. Laat dit open staan; herladen maakt het niet sneller.",
  "import.waitRationed": "Je snelle downloads voor vandaag zijn op. De rest gaat om {time} langzamer verder. Laat dit open staan.",
  "import.dailyLimit": "De dagelijkse downloadlimiet van Strava is bereikt. Probeer het na {time} opnieuw.",
  "import.dailyRationed": "Je deel van de Strava-downloads voor vandaag is op. Probeer het na {time} opnieuw.",
  "import.noActivitiesYet": "Je Strava-account heeft nog geen activiteiten. Leg er een vast of upload er een op Strava, dan verschijnt die hier.",
  "table.noActivities": "geen activiteiten",
  "table.untitled": "(zonder titel)",
  "activities.pageTitle": "{app} — Activiteitenindex",
  "activities.heading": "Activiteitenindex",
  "activities.fetching": "Activiteiten ophalen...",
  "activities.rateLimit": "Strava-limiet bereikt; hervat om {time}",
  "activities.noData": "Helaas geen gegevens &#128577;",
  "activities.colServerCache": "Track in de cache op de server (Mongo)",
  "activities.colBrowserCache": "Track in de cache van deze browser",
  "activities.cachedServer": "Track voor {id} staat in de cache op de server",
  "activities.notCachedServer": "Track voor {id} staat niet in de cache op de server",
  "activities.cachedBrowser": "Track voor {id} staat in de cache van deze browser",
  "activities.notCachedBrowser": "Track voor {id} staat niet in de cache van deze browser",
  "sport.AlpineSki": "Alpineskiën",
  "sport.BackcountrySki": "Toerskiën",
  "sport.Badminton": "Badminton",
  "sport.Basketball": "Basketbal",
  "sport.Canoeing": "Kano",
  "sport.Cricket": "Cricket",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Dansen",
  "sport.EBikeRide": "E-bikerit",
  "sport.Elliptical": "Crosstrainer",
  "sport.EMountainBikeRide": "E-mountainbikerit",
  "sport.Golf": "Golf",
  "sport.GravelRide": "Gravelrit",
  "sport.Handcycle": "Handbike",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Wandeling",
  "sport.IceSkate": "Schaatsen",
  "sport.InlineSkate": "Inlineskaten",
  "sport.Kayaking": "Kajakken",
  "sport.Kitesurf": "Kitesurfen",
  "sport.MountainBikeRide": "Mountainbikerit",
  "sport.NordicSki": "Langlaufen",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Fysiotherapie",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Racquetball",
  "sport.Ride": "Fietsrit",
  "sport.RockClimbing": "Klimmen",
  "sport.RollerSki": "Rolski",
  "sport.Rowing": "Roeien",
  "sport.Run": "Hardlopen",
  "sport.Sail": "Zeilen",
  "sport.Skateboard": "Skateboarden",
  "sport.Snowboard": "Snowboarden",
  "sport.Snowshoe": "Sneeuwschoenwandelen",
  "sport.Soccer": "Voetbal",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Stepper",
  "sport.StandUpPaddling": "Suppen",
  "sport.Surfing": "Surfen",
  "sport.Swim": "Zwemmen",
  "sport.TableTennis": "Tafeltennis",
  "sport.Tennis": "Tennis",
  "sport.TrailRun": "Trailrun",
  "sport.Velomobile": "Velomobiel",
  "sport.VirtualRide": "Virtuele fietsrit",
  "sport.VirtualRow": "Virtueel roeien",
  "sport.VirtualRun": "Virtuele loop",
  "sport.Volleyball": "Volleybal",
  "sport.Walk": "Wandelen",
  "sport.WeightTraining": "Krachttraining",
  "sport.Wheelchair": "Rolstoel",
  "sport.Windsurf": "Windsurfen",
  "sport.Workout": "Training",
  "sport.Yoga": "Yoga"
}
